import { createContext, use } from "react";

// Kept apart from OrgProvider so a hot reload of the provider never forks the context.

export interface Org {
  readonly id: string;
  readonly name: string;
  readonly userId: string;
  readonly userName: string;
  readonly role: string;
}

export const OrgContext = createContext<Org | null>(null);

/**
 * The signed-in person's active org. Every session opens in an org (convex/auth.ts
 * ensures one on session create), so inside the app frame this is never empty.
 */
export const useOrg = () => {
  const org = use(OrgContext);
  if (org === null) throw new Error("useOrg outside the app frame");
  return org;
};
